export default __webpack_public_path__ + "static/media/features-thumb-2.fc263ad4.png";